<!-- Venda -->
<sgt-config-pedido-tipo-venda-badge-venda
    *ngIf="isVenda()"
    [isAbreviacao]="isAbreviacao">
</sgt-config-pedido-tipo-venda-badge-venda>

<!-- Bonificação -->
<sgt-config-pedido-tipo-venda-badge-bonificacao
    *ngIf="isBonificacao()"
    [isAbreviacao]="isAbreviacao">
</sgt-config-pedido-tipo-venda-badge-bonificacao>

<!-- Amostra -->
<sgt-config-pedido-tipo-venda-badge-amostra
    *ngIf="isAmostra()"
    [statusAmostra]="statusAmostra"
    [isAbreviacao]="isAbreviacao">
</sgt-config-pedido-tipo-venda-badge-amostra>

<!-- Consignação -->
<sgt-config-pedido-tipo-venda-badge-consignacao
    *ngIf="isConsignacao()"
    [isAbreviacao]="isAbreviacao">
</sgt-config-pedido-tipo-venda-badge-consignacao>

<!-- Remessa -->
<sgt-config-pedido-tipo-venda-badge-remessa
    *ngIf="isRemessa()"
    [isAbreviacao]="isAbreviacao">
</sgt-config-pedido-tipo-venda-badge-remessa>

<!-- Simulação -->
<sgt-config-pedido-tipo-venda-badge-simulacao
    *ngIf="isSimulacao()"
    [isAbreviacao]="isAbreviacao">
</sgt-config-pedido-tipo-venda-badge-simulacao>

<!-- Orçamento -->
<sgt-config-pedido-tipo-venda-badge-orcamento
    *ngIf="isOrcamento()"
    [isAbreviacao]="isAbreviacao">
</sgt-config-pedido-tipo-venda-badge-orcamento>


<!-- Outro -->
<sgt-config-pedido-tipo-venda-badge-outro
    *ngIf="isOutro()"
    [isAbreviacao]="isAbreviacao">
</sgt-config-pedido-tipo-venda-badge-outro>